<template>
  <div class="select-wrap">
    <SelectGroup
      class="row-item mb15"
      pointClass="j-select-server"
      selectClass="j-select-server-ele"
      v-model="serverId"
      @change="loadRole"
    >
      <template slot="option">
        <option value="0" disabled>
          {{ letter.creatework_serverHolder }}
        </option>
        <optgroup :label="letter.yourServer">
          <option
            v-for="item in historyServerList"
            :key="item.ID"
            :value="item.ID"
          >
            {{ item.NAME }}
          </option>
        </optgroup>
        <optgroup :label="letter.allServer">
          <option v-for="item in serverList" :key="item.ID" :value="item.ID">
            {{ item.NAME }}
          </option>
        </optgroup>
      </template>
      <template slot="ico">
        <em class="ico"></em>
      </template>
    </SelectGroup>
    <Select
      v-if="roleList && roleList.length !== 0"
      class="row-item role-select mb15"
      pointClass="j-select-role"
      selectClass="j-select-role-ele"
      v-model="roleId"
    >
      <template slot="option">
        <option value="-1" disabled>
          {{ letter.selectRoleName }}
        </option>
        <option
          v-for="item in roleList"
          :key="item.roleID"
          :value="item.roleID"
        >
          {{ item.roleName }}
        </option>
      </template>
      <template slot="ico">
        <em class="ico"></em>
      </template>
    </Select>
    <Select
      v-else
      class="row-item mb15"
      v-model="roleId"
      pointClass="j-select-role"
      selectClass="j-select-role-ele"
    >
      <template slot="option">
        <option value="-1" disabled v-if="!serverId">
          {{ letter.selectRoleName }}
        </option>
        <option value="-1" disabled v-else>
          {{ letter.creatework_noRole }}
        </option>
      </template>
      <template slot="ico">
        <em class="ico"></em>
      </template>
    </Select>
    <div
      class="select-role-btn"
      :class="[
        `${isPopup ? 'j-select-role-confirm-popup' : 'j-select-role-confirm'}`
      ]"
      @click="handleLoadProduct"
    >
      {{ letter.popupConfirm }}
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import coupon from '@mixins/officialWebStore/coupon';
import login from '@mixins/officialWebStore/login';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV2';
export default {
  mixins: [login, coupon],
  props: {
    isPopup: {
      default: false
    }
  },
  data() {
    return {
      select: '',
      ico: ''
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId,
      pcServerId: state => state.pcServerId,
      roleName: state => state.roleName,
      uid: state => state.login.uid,
      serverList: state => state.serverList,
      historyServerList: state => state.historyServerList,
      roleList: state => state.roleList
    })
  },
  methods: {
    handleLoadProduct() {
      clickButton({
        btnName: 'bind_role_confirm',
        locationKey: locationType.charPopup
      });
      this.loadProduct('select_bind');
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.select-wrap {
  padding: 30px 64px 22px;
  box-sizing: border-box;
}
.row-item {
  display: block;
  position: relative;
  box-sizing: border-box;
  margin: 0 auto 20px;
  width: 602px;
  height: 80px;
  background-size: cover;
  vertical-align: top;
  font-size: 24px;
  color: #333;
  border: 1px solid #d2d2d2;
  border-radius: 10px;
  ::v-deep .select {
    color: #333;
  }
  ::v-deep .ico {
    display: inline-block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: url($tmslgImg + 'role-ico.png') no-repeat;
    width: 22px;
    height: 13px;
  }
}

.select-role-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px auto 0;
  line-height: 80px;
  height: 80px;
  font-size: 24px;
  color: #fff;
  font-weight: bold;
  background: $btnBg;
  border-radius: 10px;
  cursor: pointer;
}
</style>
